import { ClientStatusService, ResponseStatus } from '@sdbn/appclient';
import { ResponseMessage } from '@sdbn/appclient';
import { TransportAttachDetachService } from '../service/transport-attach-detach.service';
import { AttachDetachStepperModel } from '../model/attach-detach-step-model';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { TransportFormatterService } from 'src/tmc-yard/legacy/transport-formatter-service';
import { TransportAttachDetachStepperService } from '../service/transport-attach-detach-stepper.service';

@Component({
  selector: 'app-transport-attach-detach-dialog',
  templateUrl: './transport-attach-detach-dialog.component.html',
  styleUrls: ['./transport-attach-detach-dialog.component.scss']
})
export class TransportAttachDetachDialogComponent implements OnInit {

  // Determines if a server call is currently running.
  actionRunning = false;

  responseMessages: ResponseMessage[];

  identifier = ' ';
  carrier = ' ';
  driver = ' ';

  stepperModel: AttachDetachStepperModel;

  constructor(
    public dialogRef: MatDialogRef<TransportAttachDetachDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public translationService: TranslationService,
    private stepperService: TransportAttachDetachStepperService,
    private attachDetachService: TransportAttachDetachService,
    private transportFormatterService: TransportFormatterService) {

    this.stepperModel = new AttachDetachStepperModel();
    this.stepperService.setStepperModel(this.stepperModel);

    this.stepperModel.setDetails(data.details);
    this.stepperModel.lastSteps.push(...[
      AttachDetachStepperModel.STEP_DETACH_TRUCK,
      AttachDetachStepperModel.STEP_DETACH_TRUCK_AND_TRAILER,
      AttachDetachStepperModel.STEP_DETACH_TRAILER,
      AttachDetachStepperModel.STEP_ATTACH_TRUCK,
      AttachDetachStepperModel.STEP_ATTACH_TRAILER,
      AttachDetachStepperModel.STEP_TRAILER_SWAP_SOURCE_DETAILS,
      AttachDetachStepperModel.STEP_DETACH_TRAILER_SEMI_TRAILER_TRUCK]
    );

    this.setIdentifier();

    if (this.stepperModel.workingData.carrier) {
      this.carrier = this.stepperModel.workingData.carrier;
    }

    if (this.stepperModel.workingData.driver) {
      this.driver = this.stepperModel.workingData.driver;
    }
  }

  ngOnInit() {
  }

  private setIdentifier() {
    this.identifier = this.transportFormatterService.formatTransportIdentifier(this.stepperModel.workingData.identifier,
      this.stepperModel.workingData.transportScope);
  }

  showPreviousStep() {
    this.responseMessages = [];
    this.stepperModel.currentComponentIndex = this.stepperModel.getPreviousStepIndex();
  }

  showNextStep() {
    if (this.stepperModel.beforeNextStep()) {
      this.responseMessages = [];
      this.stepperModel.currentComponentIndex = this.stepperModel.getNextStepIndex();
    }
  }

  stepCompleted() {
    // no confirm possible if this falg is set in the model
    if (!this.stepperModel.workingData.confirmEnabled) {
      return false;
    }
    if (this.stepperModel.stepCompleted) {
      return this.stepperModel.stepCompleted();
    }
    return false;
  }

  isPreviousStepVisible() {
    return this.stepperModel.currentComponentIndex > 0;
  }

  showNextStepButtonVisible() {
    return !this.showFinishButtonVisible();
  }

  showFinishButtonVisible() {
    return this.stepperModel.lastSteps.indexOf(this.stepperModel.currentComponentIndex) > -1;
  }

  isActionSelection() {
    return this.stepperModel.currentComponentIndex === AttachDetachStepperModel.STEP_SELECT_ACTION;
  }

  isDetachTruck() {
    return this.stepperModel.currentComponentIndex === AttachDetachStepperModel.STEP_DETACH_TRUCK;
  }

  isDetachTruckAndTrailer() {
    return this.stepperModel.currentComponentIndex === AttachDetachStepperModel.STEP_DETACH_TRUCK_AND_TRAILER;
  }

  isDetachTrailer() {
    return this.stepperModel.currentComponentIndex === AttachDetachStepperModel.STEP_DETACH_TRAILER;
  }

  isDetachTrailerFromSemiTrailerTruck() {
    return this.stepperModel.currentComponentIndex == AttachDetachStepperModel.STEP_DETACH_TRAILER_SEMI_TRAILER_TRUCK;
  }

  isAttachTruck() {
    return this.stepperModel.currentComponentIndex === AttachDetachStepperModel.STEP_ATTACH_TRUCK;
  }

  isAttachTrailer() {
    return this.stepperModel.currentComponentIndex === AttachDetachStepperModel.STEP_ATTACH_TRAILER;
  }

  isSelectTrailerSwapTarget() {
    return this.stepperModel.currentComponentIndex === AttachDetachStepperModel.STEP_SELECT_TRAILER_SWAP_TARGET;
  }

  isTrailerSwapSourceDetails() {
    return this.stepperModel.currentComponentIndex === AttachDetachStepperModel.STEP_TRAILER_SWAP_SOURCE_DETAILS;
  }

  finish() {
    this.actionRunning = true;
    this.responseMessages = [];

    this.attachDetachService.save(this.stepperModel.workingData).subscribe(response => {
      this.actionRunning = false;
      if (response.status === ResponseStatus.SUCCESS) {
        this.dialogRef.close();
      }
      this.responseMessages = response.responseMessages;
    }, error => {
      console.log('Errow while saving data', error);
      this.actionRunning = false;
    });
  }
}
